// i18n keys of the multi-tenant work package "portalintl" — a merchant outside Thailand issues plain
// documents (owner 2026-10-03, decision C), several Profile emails (Q8), the merchant's own region in
// Admin → Portal accounts. ⛔ Fill all three: an empty th value falls back to English.
export const en: Record<string, string> = {
  pi_tab_unavailable: 'This page is not available for a company outside Thailand.',
  pi_plain_note: 'Your company is set up outside Thailand: you issue plain quotations, invoices and receipts, and you enter each line\'s tax rate yourself. Nothing here follows Thai tax rules.',
  pi_cdoc_tax_rate: 'Tax %',
  pi_cdoc_tax_rate_title: 'The tax rate for this line, in percent — 0 if none',
  pi_cdoc_tax: 'Tax',
  pi_cdoc_err_rate: 'Each line\'s tax rate must be a number from 0 to 100.',
  pi_cdoc_plain_hint: 'Enter each line\'s tax rate yourself (0 if none). The document prints "Tax" and the amount.',
  pi_crec_subtitle: 'Choosing an invoice fills in what is still owed. Change it if the money that actually arrived differs.',
  pi_crec_cash: 'Amount received',
  pi_crec_settling: 'Settling {{total}}',
  pi_erec_note: 'A receipt records money received. The customer, the amount and the date cannot be changed here — to correct them, void this receipt and record the payment again.',
  pi_conv_invoice_hint: 'An invoice in your own currency, with the tax rates of the quotation.',
  pi_prof_email_hint: 'Several addresses can be entered, separated by commas. Replies from your customers go to them and each one gets a copy of what you send.',
  pi_adm_country: 'Country',
  pi_adm_region: 'Region',
  pi_adm_region_btn: 'Set the country, currency and time zone',
  pi_adm_region_title: 'Region — {{name}}',
  pi_adm_region_hint: 'The country decides which documents this company issues from now on: Thailand (or no country at all) = Thai tax documents; any other country = plain quotations, invoices and receipts with no Thai tax content and nothing booked into Thai tax records. An empty field inherits the workspace. Every document keeps the rules it was issued under: Thai tax documents already issued stay Thai tax documents (as printed, as verified, as booked), and plain ones stay plain. A company in Thailand can only use THB.',
  pi_adm_mode_thai: 'Thai tax documents',
  pi_adm_mode_plain: 'Plain documents',
  pi_adm_inherits: '{{country}} (workspace)',
  pi_adm_save: 'Save',
  pi_adm_cancel: 'Cancel',
  pi_adm_saving: 'Saving…',
  pi_adm_no_profile: 'No merchant profile yet',
  pi_adm_company: 'Company',
  pi_adm_orphans_title: 'Merchant companies no login reaches',
  pi_adm_orphans_hint: 'Their documents are kept. Set the country here before a login is linked to one of them.',
  pi_prof_email_invalid: 'Saved, but not an email address — nothing is sent to it: {{parts}}',
};
export const zh: Record<string, string> = {
  pi_tab_unavailable: '泰国以外的公司不提供此页面。',
  pi_plain_note: '贵公司设在泰国以外:您开具的是普通报价单、发票和收据,每一行的税率由您自己填写。这里的一切都不按泰国税法处理。',
  pi_cdoc_tax_rate: '税率 %',
  pi_cdoc_tax_rate_title: '此行的税率(百分比)— 无税填 0',
  pi_cdoc_tax: '税',
  pi_cdoc_err_rate: '每一行的税率必须是 0 到 100 之间的数字。',
  pi_cdoc_plain_hint: '每一行的税率请自行填写(无税填 0)。单据上只印「Tax」和金额。',
  pi_crec_subtitle: '选择发票后会自动带出尚未收到的金额。若实际到账金额不同,可自行修改。',
  pi_crec_cash: '实收金额',
  pi_crec_settling: '本次结清 {{total}}',
  pi_erec_note: '收据记录的是已收到的款项。客户、金额和日期不能在此修改 — 如需更正,请作废本收据并重新登记该笔收款。',
  pi_conv_invoice_hint: '以贵公司自己的币种开具的发票,沿用报价单上的税率。',
  pi_prof_email_hint: '可以填写多个邮箱,用逗号分隔。客户的回复会发到这些邮箱,您发出的每份单据也会抄送给每一个邮箱。',
  pi_adm_country: '国家',
  pi_adm_region: '地区',
  pi_adm_region_btn: '设置国家、币种和时区',
  pi_adm_region_title: '地区 — {{name}}',
  pi_adm_region_hint: '国家决定这家公司今后开具哪类单据:泰国(或未设国家)= 泰国税务单据;其他任何国家 = 普通报价单、发票和收据,不含任何泰国税务内容,也不记入泰国报税账。留空的字段沿用工作区设置。每张单据都保持开具时的规则:已开出的泰国税务单据仍是泰国税务单据(打印、核验、记账都不变),普通单据仍是普通单据。设在泰国的公司只能使用 THB。',
  pi_adm_mode_thai: '泰国税务单据',
  pi_adm_mode_plain: '普通单据',
  pi_adm_inherits: '{{country}}(工作区)',
  pi_adm_save: '保存',
  pi_adm_cancel: '取消',
  pi_adm_saving: '保存中…',
  pi_adm_no_profile: '尚无商户资料',
  pi_adm_company: '公司',
  pi_adm_orphans_title: '没有任何登录账号可进入的商户公司',
  pi_adm_orphans_hint: '它们的单据都保留着。在给其中某家关联登录账号之前,请先在这里设置国家。',
  pi_prof_email_invalid: '已保存,但以下内容不是邮箱地址,不会向其发送:{{parts}}',
};
export const th: Record<string, string> = {
  pi_tab_unavailable: 'หน้านี้ไม่เปิดให้บริษัทที่อยู่นอกประเทศไทย',
  pi_plain_note: 'บริษัทของท่านตั้งอยู่นอกประเทศไทย: ท่านออกใบเสนอราคา ใบแจ้งหนี้ และใบเสร็จรับเงินแบบทั่วไป และระบุอัตราภาษีของแต่ละรายการเอง ไม่มีส่วนใดในหน้านี้ที่ใช้กฎหมายภาษีไทย',
  pi_cdoc_tax_rate: 'ภาษี %',
  pi_cdoc_tax_rate_title: 'อัตราภาษีของรายการนี้ (ร้อยละ) — ใส่ 0 หากไม่มี',
  pi_cdoc_tax: 'ภาษี',
  pi_cdoc_err_rate: 'อัตราภาษีของแต่ละรายการต้องเป็นตัวเลขตั้งแต่ 0 ถึง 100',
  pi_cdoc_plain_hint: 'กรุณาระบุอัตราภาษีของแต่ละรายการเอง (ใส่ 0 หากไม่มี) เอกสารจะพิมพ์คำว่า "Tax" และจำนวนเงินเท่านั้น',
  pi_crec_subtitle: 'เมื่อเลือกใบแจ้งหนี้ ระบบจะใส่ยอดที่ยังค้างชำระให้ แก้ไขได้หากเงินที่ได้รับจริงไม่ตรงกัน',
  pi_crec_cash: 'จำนวนเงินที่ได้รับ',
  pi_crec_settling: 'ชำระครั้งนี้ {{total}}',
  pi_erec_note: 'ใบเสร็จรับเงินเป็นหลักฐานการรับเงิน ไม่สามารถแก้ไขลูกค้า จำนวนเงิน และวันที่ได้ที่นี่ — หากต้องการแก้ไข กรุณายกเลิกใบเสร็จนี้แล้วบันทึกการรับชำระใหม่',
  pi_conv_invoice_hint: 'ใบแจ้งหนี้ในสกุลเงินของบริษัทท่าน โดยใช้อัตราภาษีตามใบเสนอราคา',
  pi_prof_email_hint: 'ใส่อีเมลได้หลายรายการ โดยคั่นด้วยเครื่องหมายจุลภาค (,) คำตอบจากลูกค้าจะส่งถึงทุกอีเมล และทุกอีเมลจะได้รับสำเนาเอกสารที่ท่านส่ง',
  pi_adm_country: 'ประเทศ',
  pi_adm_region: 'ภูมิภาค',
  pi_adm_region_btn: 'ตั้งค่าประเทศ สกุลเงิน และเขตเวลา',
  pi_adm_region_title: 'ภูมิภาค — {{name}}',
  pi_adm_region_hint: 'ประเทศเป็นตัวกำหนดว่าบริษัทนี้จะออกเอกสารแบบใดนับจากนี้: ประเทศไทย (หรือไม่ได้ระบุประเทศ) = เอกสารภาษีของไทย; ประเทศอื่นใด = ใบเสนอราคา ใบแจ้งหนี้ และใบเสร็จรับเงินแบบทั่วไป ไม่มีเนื้อหาภาษีของไทยและไม่บันทึกลงบัญชีภาษีของไทย ช่องที่เว้นว่างจะใช้ค่าของพื้นที่ทำงาน เอกสารทุกฉบับคงใช้กฎตามที่ออก: เอกสารภาษีของไทยที่ออกไปแล้วยังคงเป็นเอกสารภาษีของไทย (ทั้งการพิมพ์ การตรวจสอบ และการบันทึกบัญชี) และเอกสารทั่วไปยังคงเป็นเอกสารทั่วไป บริษัทที่อยู่ในประเทศไทยใช้ได้เฉพาะสกุลเงิน THB',
  pi_adm_mode_thai: 'เอกสารภาษีของไทย',
  pi_adm_mode_plain: 'เอกสารทั่วไป',
  pi_adm_inherits: '{{country}} (พื้นที่ทำงาน)',
  pi_adm_save: 'บันทึก',
  pi_adm_cancel: 'ยกเลิก',
  pi_adm_saving: 'กำลังบันทึก…',
  pi_adm_no_profile: 'ยังไม่มีข้อมูลร้านค้า',
  pi_adm_company: 'บริษัท',
  pi_adm_orphans_title: 'บริษัทร้านค้าที่ยังไม่มีบัญชีเข้าสู่ระบบใดเข้าถึงได้',
  pi_adm_orphans_hint: 'เอกสารของบริษัทเหล่านี้ยังคงอยู่ กรุณาตั้งค่าประเทศที่นี่ก่อนผูกบัญชีเข้าสู่ระบบกับบริษัทใดบริษัทหนึ่ง',
  pi_prof_email_invalid: 'บันทึกแล้ว แต่ข้อความต่อไปนี้ไม่ใช่อีเมล จึงจะไม่มีการส่งไปถึง: {{parts}}',
};
